import React from 'react';

export const AdminPanelAddVendedorModal = ({
  isOpen,
  vendedorForm,
  setVendedorForm,
  onClose,
  onSubmit,
}) => {
  if (!isOpen) {
    return null;
  }

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4" data-testid="admin-panel-add-vendedor-modal-overlay">
      <div className="bg-white rounded-2xl w-full max-w-md p-6" data-testid="admin-panel-add-vendedor-modal">
        <h3 className="text-xl font-bold text-gray-900 mb-4" data-testid="admin-panel-add-vendedor-title">Adicionar Vendedor</h3>
        <form onSubmit={onSubmit} className="space-y-4" data-testid="admin-panel-add-vendedor-form">
          <input
            type="text"
            placeholder="Nome completo *"
            value={vendedorForm.nome}
            onChange={(event) => setVendedorForm({ ...vendedorForm, nome: event.target.value })}
            required
            className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-purple-500"
            data-testid="admin-panel-add-vendedor-name-input"
          />
          <input
            type="email"
            placeholder="Email"
            value={vendedorForm.email}
            onChange={(event) => setVendedorForm({ ...vendedorForm, email: event.target.value })}
            className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-purple-500"
            data-testid="admin-panel-add-vendedor-email-input"
          />
          <input
            type="tel"
            placeholder="Telefone"
            value={vendedorForm.telefone}
            onChange={(event) => setVendedorForm({ ...vendedorForm, telefone: event.target.value })}
            className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-purple-500"
            data-testid="admin-panel-add-vendedor-telefone-input"
          />
          <input
            type="tel"
            placeholder="WhatsApp"
            value={vendedorForm.whatsapp}
            onChange={(event) => setVendedorForm({ ...vendedorForm, whatsapp: event.target.value })}
            className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-purple-500"
            data-testid="admin-panel-add-vendedor-whatsapp-input"
          />
          <div className="flex gap-3">
            <button
              type="button"
              onClick={onClose}
              className="flex-1 py-3 border border-gray-300 rounded-xl hover:bg-gray-50"
              data-testid="admin-panel-add-vendedor-cancel-button"
            >
              Cancelar
            </button>
            <button
              type="submit"
              className="flex-1 py-3 bg-blue-600 text-white rounded-xl hover:bg-blue-700"
              data-testid="admin-panel-add-vendedor-submit-button"
            >
              Adicionar
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};
